import React, { FC } from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./cardStyle";

interface IProps {
  className: string;
  plain?: boolean;
  profile?: boolean;
  chart?: boolean;
}

// @ts-ignore
const useStyles = makeStyles(styles);

export const Card: FC<IProps> = ({ className, children, plain, profile, chart, ...rest }) => {
  const classes = useStyles();
  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardPlain]: plain,
    [classes.cardProfile]: profile,
    [classes.cardChart]: chart,
    [className]: className !== undefined
  });
  return (
    <div className={cardClasses} {...rest}>
      {children}
    </div>
  );
};
